<template>
  <div class="partner-registration">
    <img v-if="result?.img"
      class="partner-registration__image"
      :src="result?.img"
      alt="partner-registration"
    >
    <div>
      <h2 class="partner-registration__title">
        {{ result?.title }}
      </h2>
      <PartnerList v-if="result?.list">
        <li v-for="(item, key) in result?.list" :key="key" v-html="item" />
      </PartnerList>
      <ABtn v-if="result?.button" @click="clickEvent" class="a-btn dark" :label="result?.button?.text"/>
    </div>
  </div>
</template>

<script>
import { ABtn, useAModal } from '../../ui';

export default {
  name: 'PartnerRegistration',
  props: ['result'],
  components: {
    ABtn
  },
  setup(props) {
    const modal = useAModal();

    const clickEvent = () => {
      if(props.result.authorized) {
        modal.show('InviteLink-modal');
      } else {
        console.log(props.result.messages)
        showNotification(
            'nativeInfo',
            props.result.messages.notAuthorizedTitle,
            props.result.messages.notAuthorizedText,
            {
              actions:[
                {
                  bg:'#00A59E',
                  color:'',
                  title:props.result.messages.notAuthorizedRegBtnTitle,
                  action:false,
                  paternAction:'registration'
                },
                {
                  bg:'#00A59E',
                  color:'',
                  title:props.result.messages.notAuthorizedAuthorizeBtnTitle,
                  action:false,
                  paternAction:'login'
                }
              ]
            }
        );

      }
      console.log(props.result.authorized
      )
      //


    }

    return {
      clickEvent,
    }
  }
}
</script>

<style lang="scss" scoped>
.partner-registration {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 64px;
  margin-bottom: 160px;
  @include tablet{
    margin-bottom: 60px;
  }
  @include mobile{
    grid-template-columns: 1fr;
  }
  &__image{
    border-radius: 6px;
  }
  &__title{
    margin: 0 0 37px;
  }
  :deep{
    .a-btn{
      min-width: 260px;
      @include mobile{
        width: 100%;
      }
    }
    .partner-list{
      margin-bottom: 43px;
    }
  }
}
</style>